/**
 * Merges CSS class names, filtering out falsy values.
 * Lightweight alternative to clsx/classnames for simple use cases.
 */
export function cn(
  ...classes: Array<string | undefined | null | false>
): string {
  return classes.filter(Boolean).join(' ')
}
